<script>
export let className = ""
</script>

<div class="flex {className}">
  <slot />
</div>
